export const PATH = {
    HOME: '/',
    SCHEDULE_PAYMENT_NO_ID: '/order-payment',
    BOOKING_HYSTORY: '/booking-history',
    BOOKING_DETAIL: '/booking-detail/:customerScheduleId',
    BOOKING_DETAIL_NO_ID: '/booking-detail',
    BOOKING_UPDATE: '/booking-update/:customerScheduleId',
    IFRAME_VIEW: '/page',
    PAYMENT_POLICY: '/payment-policy',
    SCHEDULE_PAYMENT: '/order-payment/:orderId',
    SCHEDULE_PAYMENT_QR: '/order-payment/:orderId/payment-qr',
}